export default __webpack_public_path__ + "static/pres_kz-ef1dfd68d62ca8ae7d0130cdbe2a9c41.png";